import React from 'react'

export const AccountsDashboard = () => {
  return (
    <div>AccountsDashboard</div>
  )
}
